// Calls to our Worker. Errors come back as readable sentences, never stack traces.

async function get(path, params, { timeout = 15000 } = {}) {
  const url = new URL(path, location.origin)
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null) url.searchParams.set(k, String(v))
  let res
  try {
    res = await fetch(url, { signal: AbortSignal.timeout(timeout) })
    // Cloudflare sometimes stops a heavy request that lands on a cold Worker (error 1102, a 503 that
    // isn't ours). Trying again (twice at most) usually lands on a warm one; our own 503s are JSON and aren't retried.
    for (const wait of [400, 1200]) {
      if (!((res.status === 503 || res.status === 500) && !(res.headers.get('Content-Type') || '').includes('json'))) break
      await new Promise((r) => setTimeout(r, wait))
      res = await fetch(url, { signal: AbortSignal.timeout(timeout) })
    }
  } catch (e) {
    throw new Error(e?.name === 'TimeoutError' ? 'That took too long. Check your connection and try again.' : "Couldn't reach the server. Check your connection.")
  }
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(body.error || `Something went wrong (${res.status}).`)
  return body
}

export const getPlan = (at, win, origin, freeOnly) =>
  get('/api/plan', { lat: at.lat.toFixed(6), lon: at.lon.toFixed(6), start: win.start, end: win.end, olat: origin?.lat?.toFixed(6), olon: origin?.lon?.toFixed(6), free: freeOnly ? 1 : undefined })
export const getCurb = (id, win, since) => get('/api/curb', { id, start: win.start, end: win.end, since })
export const getHere = (at, win) => get('/api/here', { lat: at.lat.toFixed(6), lon: at.lon.toFixed(6), start: win.start, end: win.end })
export const geocode = (q, near, done) => get('/api/geocode', { q, lat: near?.lat?.toFixed(3), lon: near?.lon?.toFixed(3), done: done ? 1 : undefined }, { timeout: 12000 })

export function report(curb, kind) {
  // Test runs (npm run e2e against production) set this so they don't feed the crowd reports.
  try { if (localStorage.getItem('parking:noreport')) return } catch {}
  // Fire and forget; keepalive lets it finish while the page hands off to Maps.
  fetch('/api/report', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ curb, kind }), keepalive: true }).catch(() => {})
}
